import '@cbhq/cds-fonts/fonts.css';
import '@cbhq/cds-icons/fonts/web/icon-font.css';
import '@cbhq/cds-icons/fonts/web/icon-font.css';
import '@cbhq/cds-web/globalStyles';

import { createRoot } from 'react-dom/client';

import { initAnalytics } from './init/analytics';
import { App } from './App';

initAnalytics();

createRoot(document.getElementById('root') as HTMLElement).render(<App />);
